import React from 'react';
import { bool, func, node, object, shape, string } from 'prop-types';
import classNames from 'classnames';

import { FormattedMessage } from '../../../../util/reactIntl';
import Field, { hasDataInFields } from '../../Field';

import SectionContainer from '../SectionContainer';
import SearchForm from './SearchForm/SearchForm';
import css from './SectionHero.module.css';

// Section component for a website's hero section
// The Section Hero doesn't have any Blocks by default, all the configurations are made in the Section Hero settings
const SectionHero = props => {
  const {
    sectionId,
    className,
    rootClassName,
    defaultClasses,
    title,
    description,
    appearance,
    callToAction,
    options,
    setFormModalOpen,
  } = props;

  // If external mapping has been included for fields
  // E.g. { h1: { component: MyAwesomeHeader } }
  const fieldComponents = options?.fieldComponents;
  const fieldOptions = { fieldComponents };

  const hasHeaderFields = hasDataInFields([title, description, callToAction], fieldOptions);

  // console.log(callToAction)

  const callToActionCustom = {
    content: "WHATSAPP US",
    fieldType: callToAction.fieldType,
    href: callToAction.href,
  }

  return (
    <SectionContainer
      id={sectionId}
      className={className}
      rootClassName={classNames(rootClassName || css.root)}
      appearance={appearance}
      options={fieldOptions}
    >
      {hasHeaderFields ? (
        <header className={defaultClasses.sectionDetails}>
          <Field data={title} className={classNames(defaultClasses.title, css.customTitle)} options={fieldOptions} />
          <Field data={description} className={classNames(css.customDescription, defaultClasses.description)} options={fieldOptions} />
          <div className={css.buttonsContainer}>
            <a
              className={classNames(defaultClasses.ctaButton, css.customCtaButton)}
              onClick={() => setFormModalOpen(true)}
            >
              <FormattedMessage id="LandingContactForm.ctaButton" />
            </a>
            <Field data={callToActionCustom} className={classNames(defaultClasses.ctaButton, css.halfWidth)} options={fieldOptions} />
          </div>
          <SearchForm />
        </header>
      ) : null}
    </SectionContainer >
  );
};

const propTypeOption = shape({
  fieldComponents: shape({ component: node, pickValidProps: func }),
});

SectionHero.defaultProps = {
  className: null,
  rootClassName: null,
  defaultClasses: null,
  textClassName: null,
  title: null,
  description: null,
  appearance: null,
  callToAction: null,
  isInsideContainer: false,
  options: null,
};

SectionHero.propTypes = {
  sectionId: string.isRequired,
  className: string,
  rootClassName: string,
  defaultClasses: shape({
    sectionDetails: string,
    title: string,
    description: string,
    ctaButton: string,
  }),
  title: object,
  description: object,
  appearance: object,
  callToAction: object,
  isInsideContainer: bool,
  options: propTypeOption,
};

export default SectionHero;
